@if (searchResults$ | async; as searchResults) {
  @if (!searchResults?.title && !searchResults?.categoryLongDescription) {
    <div  class="h2-component title">
      <!-- {{breadcrumbs ? breadcrumbs[0].facetValueName : ('productList.findTitle'| cxTranslate : {searchText: searchResults?.freeTextSearch})}} -->
    </div>
  }
  <!--  <p class="description" *ngIf="searchResults?.categoryDescription" [innerHTML]="searchResults?.categoryDescription"></p>-->
}

